// customerSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customer: null,
  username: "",
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    updateCustomer: (state, action) => {
      state.customer = action.payload;
      state.username = action.payload.Firstname + " " + action.payload.Lastname;
    },
    setusername: (state, action) => {},
  },
});

export const { updateCustomer, setusername } = customerSlice.actions;
export default customerSlice.reducer;
